import { useEffect, useState } from "react";
import { api } from "./client";

export interface TextFeature { key: "sms_shift_offers_enabled" | "sms_crew_alerts_enabled"; label: string; enabled: boolean; note: string }
export const textFeaturesApi = {
  status: () => api.get<{ features: TextFeature[] }>("/admin/settings/text-features"),
  set: (key: string, enabled: boolean, code: string) => api.put<{ features: TextFeature[] }>(`/admin/settings/text-features/${key}`, { enabled, code }),
};

/** null while loading. */
export function useOffersEnabled(): boolean | null {
  const [on, setOn] = useState<boolean | null>(null);
  useEffect(() => { textFeaturesApi.status().then((r) => setOn(!!r.features.find((f) => f.key === "sms_shift_offers_enabled")?.enabled)).catch(() => setOn(false)); }, []);
  return on;
}
